import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Figure } from '@studiometa/ui';
import { isDev } from './config.js';
import Header from './components/Header.js';
import Loader from './components/Loader.js';
import Programmation from './components/Programmation.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Video: Array<Promise<import('./components/Video.js').default>>
 *     Accordion: Array<Promise<import('./components/Accordion.js').default>>
 *     Slider: Array<Promise<import('./components/Slider.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    log: isDev(),
    components: {
      Figure,
      Loader,
      Action,
      Header,
      Programmation,
      Slider: (app) => importWhenVisible(() => import('./components/Slider.js'), 'Slider', app),
      Video: (app) => importWhenVisible(() => import('./components/Video.js'), 'Video', app),
      Accordion: (app) =>
        importWhenVisible(() => import('./components/Accordion.js'), 'Accordion', app),
    },
  };
}

export default createApp(App, document.body);
